import React from "react";
import { Header, HeaderLogout, HeaderTop } from "../components/headers";
import { FooterLink } from "../components/footers";

class ThankYou extends React.Component {
  constructor() {
    super()
    this.token = localStorage.getItem("authToken");

    this.state = {
    }
  }

  render() {
    const { userData } = this.props.location.state;
    return (
      <React.Fragment>
        {localStorage.getItem("authToken") == null ? (
          <HeaderTop />
        ) : (
          <HeaderLogout
            currencies={this.state.currencies}
            convertToCurrency={this.state.convertToCurrency}
            changeConvertToCurrency={this.changeConvertToCurrency}
          />
        )}

        <Header />
        <section className="thankYouWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center"><h1 style={{ color: "#28a745" }}>Thank you for joining</h1></div>
            </div>
            <div className="row justify-content-center">
              {
              userData.account_type == "jobseeker" ? 
              <div className="col-md-12 text-center"><p style={{ color: "#5a5a5a" }}>You can now <a href="/login">login here</a> to access your account.</p></div>
              : 
              <div className="col-md-12 text-center"><p style={{ color: "#5a5a5a" }}>Please check your inbox and spam folder to get the activation link.</p></div>
              }
            </div>
          </div>
        </section>

        <FooterLink />
      </React.Fragment>
    );
  }
}

export default ThankYou;
